export default [
  {
    path: '/index',
    redirect: '/',
    hidden: true
  },
  {
    path: '/',
    redirect: '/home',
    hidden: true
  }
]
